export default {
  'app.settings.menuMap.basic': 'ძირითადი პარამეტრები',
  'app.settings.menuMap.security': 'უსაფრთხოების პარამეტრები',
  'app.settings.menuMap.binding': 'ანგარიშის მიბმა',
  'app.settings.menuMap.notification': 'ახალი შეტყობინების გაფრთხილება',
  'app.settings.basic.avatar': 'ავატარი',
  'app.settings.basic.change-avatar': 'ავატარის შეცვლა',
  'app.settings.basic.email': 'ელ. ფოსტა',
  'app.settings.basic.email-message': 'გთხოვთ შეიყვანოთ თქვენი ელ. ფოსტა!',
  'app.settings.basic.nickname': 'მეტსახელი',
  'app.settings.basic.nickname-message': 'გთხოვთ შეიყვანოთ თქვენი მეტსახელი!',
  'app.settings.basic.profile': 'პირადი პროფილი',
  'app.settings.basic.profile-message': 'გთხოვთ შეიყვანოთ თქვენი პირადი პროფილი!',
  'app.settings.basic.profile-placeholder': 'თქვენს შესახებ მოკლე აღწერა',
  'app.settings.basic.country': 'ქვეყანა/რეგიონი',
  'app.settings.basic.country-message': 'გთხოვთ შეიყვანოთ თქვენი ქვეყანა!',
  'app.settings.basic.geographic': 'პროვინცია ან ქალაქი',
  'app.settings.basic.geographic-message': 'გთხოვთ შეიყვანოთ გეოგრაფიული ინფორმაცია!',
  'app.settings.basic.address': 'მისამართი',
  'app.settings.basic.address-message': 'გთხოვთ შეიყვანოთ თქვენი მისამართი!',
  'app.settings.basic.phone': 'ტელეფონის ნომერი',
  'app.settings.basic.phone-message': 'გთხოვთ შეიყვანოთ თქვენი ტელეფონის ნომერი!',
  'app.settings.basic.update': 'ინფორმაციის განახლება',
  'app.settings.security.strong': 'ძლიერი',
  'app.settings.security.medium': 'საშუალო',
  'app.settings.security.weak': 'სუსტი',
  'app.settings.security.password': 'ანგარიშის პაროლი',
  'app.settings.security.password-description': 'მიმდინარე პაროლის სიძლიერე',
  'app.settings.security.phone': 'უსაფრთხოების ტელეფონი',
  'app.settings.security.phone-description': 'მიბმული ტელეფონი',
  'app.settings.security.question': 'უსაფრთხოების კითხვა',
  'app.settings.security.question-description':
    'უსაფრთხოების კითხვა არ არის დაყენებული, უსაფრთხოების პოლიტიკა ეფექტურად დაიცავს ანგარიშს',
  'app.settings.security.email': 'სარეზერვო ელ. ფოსტა',
  'app.settings.security.email-description': 'მიბმული ელ. ფოსტა',
  'app.settings.security.mfa': 'MFA მოწყობილობა',
  'app.settings.security.mfa-description':
    'მიბმული არაა MFA მოწყობილობა, მიბმის შემდეგ საჭიროა დამატებითი დადასტურება',
  'app.settings.security.modify': 'შეცვლა',
  'app.settings.security.set': 'დაყენება',
  'app.settings.security.bind': 'მიბმა',
  'app.settings.binding.taobao': 'Taobao-ს მიბმა',
  'app.settings.binding.taobao-description': 'ამჟამად Taobao ანგარიში არ არის მიბმული',
  'app.settings.binding.alipay': 'Alipay-ის მიბმა',
  'app.settings.binding.alipay-description': 'ამჟამად Alipay ანგარიში არ არის მიბმული',
  'app.settings.binding.dingding': 'DingTalk-ის მიბმა',
  'app.settings.binding.dingding-description': 'ამჟამად DingTalk ანგარიში არ არის მიბმული',
  'app.settings.binding.bind': 'მიბმა',
  'app.settings.notification.password': 'ანგარიშის პაროლი',
  'app.settings.notification.password-description':
    'სხვა მომხმარებლების შეტყობინებები მოგივათ წერილის სახით',
  'app.settings.notification.messages': 'სისტემური შეტყობინებები',
  'app.settings.notification.messages-description': 'სისტემური შეტყობინებები მოგივათ წერილის სახით',
  'app.settings.notification.todo': 'გასაკეთებელი შეტყობინება',
  'app.settings.notification.todo-description': 'გასაკეთებელ დავალებებს მიიღებთ შეტყობინების სახით',
  'app.settings.open': 'გახსნა',
  'app.settings.close': 'დახურვა',
};
